<!-- -mx-* cancels main.component's side margins: the carousel and the avantages row run edge to edge, the rest
uses setycore's page gutter (see home.component.scss). -->
<div class="pb-9 -mt-5 -mx-4 sm:-mx-6 md:-mx-10 lg:-mx-16 overflow-x-clip">
  <div class="home-gutter w-full pt-5">
    <lib-accueil-sety-core *ngIf="pageLoaded" [labels]="'lib.accueilSetyCore' | translate" [theme]="theme"
      [slides]="slides" [autoPlay]="autoPlay"
      [autoPlayInterval]="autoPlayInterval" [showArrows]="showArrows" [showDots]="showDots" [title]="title | translate"
      [subtitle]="subtitle" [productsList]="productsList" [contactUsLink]="contactUsLink"
      [bottomLinkLabel]="'homePage.home.contactUsLabel' | translate"
      [discoverProductsLink]="discoverProductsLink"
      [bottomCtaLabel]="'homePage.home.discoverProductsLabel' | translate"
      [topCategoriesTitle]="'homePage.home.topCategoriesTitle' | translate"
      [topCategoriesSubtitle]="'homePage.home.topCategoriesSubtitle' | translate" [categories]="topCategories"
      (categoryClick)="onTopCategoryClick($event)" (selectedProduct)="handleSelectedProduct($event)"
      (addToCart)="onAddToCart($event)" [wishlistedIds]="wishlistedProductIds"
      (toggleWishlist)="handleToggleWishlist($event)">
    </lib-accueil-sety-core>
    <section *ngIf="pageLoaded" class="brands-section mb-8">
      <lib-brands [labels]="'lib.brands' | translate" [bank]="theme" [brands]="brands" [brandCWidthClass]="'w-24'"
        (brandClicked)="onBrandClicked($event)"></lib-brands>
    </section>

  </div>
</div>

<lib-add-product-popup-setycore [labels]="'lib.addProductPopup' | translate" [showPopup]="showAddPopup" [productName]="popupConfiguration?.name || ''"
  [Quantity]="popQuantity" [availableQuantity]="popupAvailableQuantity" [price]="popupConfiguration?.price || 0"
  [imgUrl]="popupConfiguration?.images?.[0]?.url || DEFAULT_PRODUCT_IMAGE"
  (showPopupChange)="onShowAddPopupChange($event)" (onseeCart)="onSeeCart()"
  (oncontinueShopping)="onContinueShopping()"></lib-add-product-popup-setycore>

@if (showSnackbar) {
<div class="relative z-[9999]">
  <lib-snackbar [labels]="'lib.snackbar' | translate" [bank]="theme" [theme]="snackbarTheme" [title]="snackbarText" [showIconLeft]="true"
    [showIconRight]="false" [position]="'bottom'"></lib-snackbar>
</div>
}

@if (showPasswordChangedPopup) {
<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]">
  <lib-modal [labels]="'lib.modal' | translate" [buttonLabel]="'homePage.home.passwordChangedButton' | translate"
    [title]="'homePage.home.passwordChangedTitle' | translate" [bank]="theme"
    [imageName]="'success.svg'" (buttonClicked)="goToLoginModal()"
    (closeModal)="closePasswordChangedPopUp()"></lib-modal>
</div>
}

<!-- Login Modal -->
@if (showLoginModal) {
<app-login-dialog (close)="closeLoginModal()"></app-login-dialog>
}